/**
 * Team Coaches API Service
 * CRUD for a team's head coach contact info (1:1 with Team).
 */

import { get, post, put, del, ApiError } from "./api";
import type { TeamCoachPayload, TeamCoachResponse } from "../types/api";

/**
 * Fetch a team's coach contact info. Resolves to null when none exists.
 */
export const getTeamCoach = async (
  teamId: string
): Promise<TeamCoachResponse | null> => {
  try {
    return await get<TeamCoachResponse>(`/api/teams/${teamId}/coach`);
  } catch (err) {
    if (err instanceof ApiError && err.statusCode === 404) {
      return null;
    }
    throw err;
  }
};

export const createTeamCoach = async (
  teamId: string,
  payload: TeamCoachPayload
): Promise<TeamCoachResponse> => {
  return post<TeamCoachResponse>(`/api/teams/${teamId}/coach`, payload);
};

export const updateTeamCoach = async (
  teamId: string,
  payload: TeamCoachPayload
): Promise<TeamCoachResponse> => {
  return put<TeamCoachResponse>(`/api/teams/${teamId}/coach`, payload);
};

export const deleteTeamCoach = async (teamId: string): Promise<void> => {
  return del<void>(`/api/teams/${teamId}/coach`);
};
